import { useLocation } from 'react-router-dom';

// 修复useLocation在Router组件外使用时的报错
const useSafeLocation = () => {
    try {
        return useLocation();
    } catch (error) {
        return null;
    }
};

export default useSafeLocation;
